import { ReactNode } from 'react';
import { Typography, Modal, Box } from '@mui/material';

import { Button, ButtonProps } from '@/components/ui/button';

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title: ReactNode;
  content: ReactNode;
  cancelButtonText: string;
  confirmButtonText: string;
  confirmButtonVariant: ButtonProps['variant'];
  onCancel?: () => void;
  onConfirm?: () => void;
  width?: string;
  gap?: string;
  marginTop?: string;
}

export default function ConfirmationModal({
  open,
  title,
  content,
  cancelButtonText,
  confirmButtonText,
  confirmButtonVariant,
  onCancel,
  onConfirm,
  width = '448px',
  gap = '16px',
  marginTop = '16px',
}: ModalProps) {
  return (
    <Modal open={open}>
      <Box
        display="flex"
        flexDirection="column"
        gap={gap}
        width={width}
        sx={{
          padding: '24px',
          bgcolor: 'white',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          borderRadius: '12px',
          outline: 'none',
        }}
      >
        {typeof title === 'string' ? (
          <Typography
            variant="body1"
            sx={{ color: 'fileInput.dark', fontWeight: 600 }}
          >
            {title}
          </Typography>
        ) : (
          title
        )}

        {typeof content === 'string' ? (
          <Typography variant="body2">{content}</Typography>
        ) : (
          content
        )}
        <Box
          display="flex"
          marginTop={marginTop}
          gap="12px"
          justifyContent="flex-end"
          height="32px"
        >
          <Button variant="outline" onClick={onCancel}>
            {cancelButtonText}
          </Button>
          <Button onClick={onConfirm} variant={confirmButtonVariant}>
            {confirmButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
